// import './icons/icons__config'; // icon font import
import "./sprites";
import debug from "debug";

const log = debug("site__csl001");

$(() => {
  log("ready");
});



// WEBPACK FOOTER //
// ./client/src/site__csl001/components/site/index.js